module.exports = __webpack_public_path__ + "media/moreCoin2.99a007b8.mp3";